import { useQuery } from "@tanstack/react-query";
import { getPromoCode } from "src/api/referrals/referrals";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetPromoCode = () => {
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [QUERYKEYS.PROMO_CODE],
    queryFn: () => getPromoCode(),
  });

  return {
    isSuccess,
    data,
    isError,
    isLoading,
    refetchPromoCode: refetch,
  };
};
